import * as server from "@/utils/http"

export const _page = params => server.get("/task-info/page", params);
export const _get = params => server.get("/task-info/get", params);
export const _getTaskInfoQRCode = params => server.get("/task-info/getTaskInfoQRCode", params);
export const _downloadQrCode = params => server.download("/task-info/download-qrCode", params);
export const _linkReport = params => server.get("/task-info/link-report", params);
export const _generateReport = params => server.post("/task-info/generate-report", params);
export const _lisPush = params => server.get("/task-info/lis-push", params);
export const _updateStatus = params => server.get("/task-info/updateStatus", params);
export const _save = params => server.post(params.id ? "/task-info/update" : "/task-info/save", params);

